export default {
  logo:{
    title: ' Senyum Dental Clinic',
  },
  header: {
    menu: 'Menu',
    contact: 'Contact Us',
    nav: {
      home: 'Home',
      services: 'Services',
      insurance: 'Panel',
      about: 'About',
      contact: 'Contact'
    }
  },
  about:{
    title:'Welcome to Senyum Dental',
    description:{
      first:'Welcome to Senyum Dental Clinic! In Bahasa Malaysia, "SENYUM" means to "SMILE," and true to our name, we are dedicated to crafting healthy and confident smiles for every patient. Nestled in the heart of Kuala Lumpur, Senyum Dental Clinic is your trusted destination for comprehensive dental care for patients of all ages.',
      second:'Conveniently located at the heart of Kuala Lumpur, at Nu Sentral mall, our team boasts over 20 years experience in the dental industry, consistently delivering high-quality oral health services. We frequently have the honor of participating in radio and television programs, lectures, and events, where we address inquiries about Wisdom Tooth, Dental Implants, and various other dental topics while sharing valuable insights.',
      third:'At Senyum Dental Clinic, we emphasize patient-centered care, creating a warm, inviting, and compassionate atmosphere to ensure that every patient enjoys personalized treatment and exceptional attention. We look forward to helping you achieve your best smile!',
      
    },
    team:{
      profile:{
        name:'Dr Nicholas Yeo',
        role:'Dentist',
        description:'BDS (University of Malaya)',
      },
      title:'Our Team',
    },
    location:{
      title:'Senyum Dental Clinic (Nu Sentral)',
      findus:'Senyum Dental Clinic is conveniently located just a short 5-minute walk from KL Sentral. You can easily reach us by public transport via the LRT, MRT, Monorail, Bus, or Train, as we are accessible through the KL Sentral station building, which leads to Nu Sentral Shopping Center. We\'re here to make your journey to a brighter smile as smooth and easy as possible. (We Are at Level 3, same level with Harvey Norman; Opposite Nyonya Colours Restaurant)',
    },
    clinic:{
      title:'Our Clinic',
    },
    contact:{
      title:'Contact Us',
      form:{
        name:'Name',
        email:'e-mail',
        message:'Message',
        submit:'Submit'
      }
    },
  },
  hero:{
    cards:{
      process:'',
      caring:'',
    },
    title:'Welcome to Senyum Dental Clinic',
    subtitle:'Your smile, our passion',
    consultation:{
      title:'Experience Pain-Free Dentistry. Schedule Your Visit.',
      subtitle:'',
      subsubtitle:'We are dedicated to crafting healthy and confident smiles for every patient. Nestled in the heart of Kuala Lumpur, Senyum Dental Clinic is your trusted destination for comprehensive dental care for patients of all ages.',  
      cta:'Contact Us to Learn More! '
    }
  },
  insurance:{
    panel: {
      title: 'Panel Clinic',
      subtitle: 'We partner with most major insurance and medical benefit providers. Our team will assist you in verifying your coverage and processing claims.',
    },
    title:'Insurance Panel Partners',
    subtitle:'We are an official panel clinic for major insurance and medical benefit providers, contact us to enquire further',
  },
  services: {
    title: 'Our Services',
    description: 'Senyum Dental Clinic offers a wide range of dental services:',
  },
  serviceCategories2:{
    category: [
      {
        title: 'Routine Procedures',
        services: [
          'Signature Ultrasonic Painless Scaling & Polishing (recognized by THE MALAYSIA BOOK OF RECORDS)',
          'Teeth Whitening (recognized by THE MALAYSIA BOOK OF RECORDS)'
        ],
        image: '/images/services/routine.jpg'
      },
      {
        title: 'Treatments',
        services: [
          'Gap & Fillings',
          'Normal Extraction',
          'Wisdom Tooth Extraction',
          'Aesthetic Dental Treatment'
        ],
        image: '/images/services/treatments.jpg'
      },
      {
        title: 'Advanced Restorative Treatments',
        services: [
          'Dental Implants',
          'Braces',
          'Clear Aligners (Certified Invisalign and Angel Aligners Provider)',
          'Dentures',
          'Veneers',
          'Retainers',
          'Root Canal',
          'Laser Treatment',
          'Crowns',
          'Bridges'
        ],
        image: '/images/services/dental_implant.jpeg'
      },
      {
        title: 'Specialties',
        services: [
          'Wisdom Tooth Removal',
          'Dental Implant',
          'Myobrace system for correcting harmful oral habits in young patients',
          'Child care services'
        ],
        image: '/images/services/specialties.jpg'
      },
      {
        title: 'Technology',
        services: [
          'High-Tech Dental Equipment',
          '3D scanning',
          '3D X-rays',
          'CBCT',
          'OPG',
          'PA',
          'Dental Microscope',
          'Laser technology'
        ],
        image: '/images/services/technology.jpg'
      }
    ]
  },
  carousel: {
    slides: {
      smile: {
        alt: 'Happy patient smiling',
        caption: 'Creating Beautiful Smiles',
        description: 'Experience comfortable and professional dental care'
      },
      facility: {
        alt: 'Modern treatment room',
        caption: 'State-of-the-Art Facilities',
        description: 'Advanced equipment for precise treatments'
      },
      technology: {
        alt: 'Advanced dental equipment',
        caption: 'Modern Technology',
        description: 'Latest dental technology for optimal results'
      },
      record: {
        alt: 'We are also honored to have earned a distinguished place in THE MALAYSIA BOOK OF RECORDS, recognized for our exceptional achievement for our Ultrasonic Painless Scaling & Polishing and Teeth Whitening Treatments.',
        //caption: 'Award Winning Clinic',
        //description: 'Malayia Book of Records Winner for Ultrasonic Painless Teeth Whitening Treatment'
        caption:'',
        description:'',
      }
    }
  },
  footer:{
    address:{
      text:'Get in touch',
      note:'We Are at Level 3, same level with Harvey Norman; Opposite Nyonya Colours'
    },
    openinghours:{
      text:'Opening Hours',
      dailies:'Daily',
      description:'Open everyday including public holidays',
    },
    links:{
      title:'Quick Links',
    }
  },
  treatments: {
    // ... existing treatments
    dentalImplant: {
      title: 'Dental Implant',
      subtitle: 'Advanced implant solutions for a confident smile',
      description: {
        intro: 'At Senyum Dental Clinic, we have a team of experienced dentists with over 15 years of expertise, equipped with high-tech facilities, focusing on providing quality dental implant services. We utilize advanced implant technology to ensure that each patient receives a safe, effective, and painless treatment experience.',
        details: 'Dental implants not only restore chewing function but also improve facial contours and boost self-confidence. We offer personalized treatment plans tailored to each patients oral condition and needs, designing the most suitable implant solutions. Additionally, our high-tech equipment makes the surgical process more precise, reducing recovery time and significantly alleviating post-operative discomfort for patients.'
      },
      benefits: {
        title: 'Key Benefits',
        items: [
          {
            title: 'Improved Aesthetics',
            description: 'They look and function like natural teeth, enhancing your smile and facial appearance.'
          },
          {
            title: 'Improved Function',
            description: 'Implants allow for easy biting, chewing, and speaking.'
          },
          {
            title: 'Durability',
            description: 'They are a long-term solution that can last a lifetime with proper care.'
          },
          {
            title: 'Bone Preservation',
            description: 'Implants prevent jawbone loss, maintaining structural integrity.'
          },
          {
            title: 'Preservation of Adjacent Teeth',
            description: 'Unlike traditional bridges, they don\'t affect neighboring teeth.'
          },
          {
            title: 'Improved Oral Health',
            description: 'Easy to clean, they promote good oral hygiene.'
          },
          {
            title: 'Convenience',
            description: 'Fixed in your mouth, no need for removable dentures.'
          },
          {
            title: 'Enhanced Comfort',
            description: 'Implants are comfortable and don\'t cause discomfort.'
          },
          {
            title: 'Speech Improvement',
            description: 'They enable clear and natural speech.'
          },
          {
            title: 'Increased Self-Confidence',
            description: 'Boosts self-esteem with a natural-looking solution.'
          },
          {
            title: 'Long-Term Cost Savings',
            description: 'While the initial cost is higher, they save money over time by reducing replacements.'
          }
        ]
      },
      image: {
        alt: 'Dental implant procedure'
      }
    }
  }
  // ... rest of the translations remain unchanged
}